export default __webpack_public_path__ + "static/media/6.9ec28f44.png";